import { i18n } from '@lingui/core'

/**
 * Dynamically load and activate a locale.
 * Catalogs are lazy-loaded to reduce initial bundle.
 */
export async function loadLocale(locale: string) {
  const { messages } = await import(`./locales/${locale}/messages.po`)
  i18n.load(locale, messages)
  i18n.activate(locale)
}

/**
 * Get the user's preferred locale from storage or browser.
 */
export function getDefaultLocale(): string {
  // Check persisted preference
  const stored = localStorage.getItem('crew-app-locale')
  if (stored && ['en', 'es'].includes(stored)) {
    return stored
  }

  // Auto-detect from browser
  const browserLang = navigator.language.split('-')[0]
  if (['en', 'es'].includes(browserLang)) {
    return browserLang
  }

  return 'en'
}

/**
 * Persist locale preference and activate it.
 */
export async function setLocale(locale: string) {
  localStorage.setItem('crew-app-locale', locale)
  await loadLocale(locale)
}

/**
 * Get the currently active locale.
 */
export function getLocale(): string {
  return i18n.locale || getDefaultLocale()
}

export { i18n }
